import React from 'react';
interface Option<T extends string> {
  value: T;
  label: string;
  /** Optional color-dot class shown before the label */
  dot?: string;
}
interface SegmentedControlProps<T extends string> {
  label: string;
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
}
export function SegmentedControl<T extends string>({
  label,
  options,
  value,
  onChange
}: SegmentedControlProps<T>) {
  return <div role="radiogroup" aria-label={label} className="inline-flex rounded-xl border border-line bg-surface p-1 shadow-card" data-id="element-138" data-mp="3qm9axwr3hut9">
      {options.map(opt => {
      const active = opt.value === value;
      return <button key={opt.value} type="button" role="radio" aria-checked={active} onClick={() => onChange(opt.value)} className={`relative flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${active ? 'text-on-accent' : 'text-muted hover:text-ink'}`} data-id="element-139" data-mp="3ho73aycuw3x0">
            {active && <span className="absolute inset-0 rounded-lg bg-accent" aria-hidden data-id="element-140" data-mp="3mie3qu78ce9j" />}
            {opt.dot && <span className={`relative h-2 w-2 shrink-0 rounded-full ${opt.dot} ${active ? 'ring-2 ring-on-accent/80' : ''}`} aria-hidden data-id="element-141" data-mp="93cnk26x0el" />}
            <span className="relative" data-id="element-142" data-mp="38poemgwemt87">{opt.label}</span>
          </button>;
    })}
    </div>;
}